var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:['nav-item', _vm.open ? 'open' : null]},[(_vm.children > 0)?_c('div',{staticClass:"nav_open",on:{"click":function($event){_vm.open = _vm.open ? false : true}}}):_vm._e(),_vm._t("menu-mobile-children")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }